<template>
  <v-select
    :items="areaList"
    v-bind="$attrs"
    label="违章区域"
    prepend-icon="$vuetify.icons.location"
    @input="$emit('input', $event)"
    :value="value"
  ></v-select>
</template>

<script>
export default {
  name: 'selectViolationArea',
  props: ['value'],
  computed: {
    areaList () {
      return this.$store.state.violation.areaList
    }
  },
  async created () {
    try {
      await this.$store.dispatch('violation/getArea')
    }
    catch (e) {
      this.$L.error(e.message)
    }
  }
}
</script>

<style scoped>

</style>
